// @ts-nocheck
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ownerApi } from './ownerApi';
import { label } from './lib/labels';
import Button from './ui/Button';
import OverflowMenu from './ui/OverflowMenu';
import ConfirmDialog from './ui/ConfirmDialog';

/** @param {{ users: any[], tenantId: string, onNotice: (text: string) => void }} props */
export default function OwnerPeople({ users, tenantId, onNotice }) {
  const navigate = useNavigate();
  const [pending, setPending] = useState(/** @type {any} */ (null));
  const rows = users || [];
  return (
    <section className="mt-4">
      <h3 className="text-sm font-semibold">People</h3>
      {rows.length === 0 ? <p className="mt-2 text-sm text-slate-600">No people on this business yet.</p> : null}
      <ul className="mt-2 divide-y divide-slate-100">
        {rows.map((user) => (
          <li key={user.id} className="flex items-center justify-between gap-3 py-2">
            <p className="text-sm">{user.email} · {label('role', user.role)}</p>
            <OverflowMenu
              items={[
                { id: 'block', label: 'Block', danger: true, onClick: () => setPending({ kind: 'block', user }) },
                { id: 'reset', label: 'Reset password', onClick: () => setPending({ kind: 'reset', user }) },
                {
                  id: 'chat',
                  label: 'Chat history',
                  onClick: () => navigate(`/owner/messages?tenant=${encodeURIComponent(tenantId)}`),
                },
              ]}
            />
          </li>
        ))}
      </ul>
      {pending?.kind === 'block' ? (
        <ConfirmDialog
          title={`Block ${pending.user.email}?`}
          body="They will not be able to sign in. No data is deleted."
          confirmLabel="Block"
          onClose={() => setPending(null)}
          onConfirm={async () => {
            await ownerApi.updateUser(pending.user.id, { status: 'blocked' });
            onNotice(`${pending.user.email} is blocked.`);
            setPending(null);
          }}
        />
      ) : null}
      {pending?.kind === 'reset' ? (
        <ConfirmDialog
          title={`Send a password reset to ${pending.user.email}?`}
          body="They will receive a reset link at that address. Their current password stops working after they set a new one."
          confirmLabel="Send reset"
          onClose={() => setPending(null)}
          onConfirm={async () => {
            await ownerApi.requestPasswordReset(pending.user.email);
            onNotice(`Password reset sent to ${pending.user.email}.`);
            setPending(null);
          }}
        />
      ) : null}
      {rows.length === 0 ? <Button variant="tertiary" className="mt-2" disabled>Invite is not available here</Button> : null}
    </section>
  );
}
